import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import type { RootState, AppDispatch } from "./store";
import { Slice } from "@reduxjs/toolkit";

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export function useReduxState<S>(
  stateSlice: Slice
): [S, (newState: S) => void] {
  const dispatch = useAppDispatch();
  return [
    useAppSelector((state: any) => state[stateSlice.name].value),
    (newState: S) => dispatch(stateSlice.actions.setState(newState)),
  ];
}
